import { Dependencies } from 'src/feature-app';

let featureServicesMirror: Dependencies = null;

export const saveFeatureServices = (featureServices: Dependencies) => {
  featureServicesMirror = featureServices;
};

export const getDataServiceConfig = () => featureServicesMirror['service-config-provider'].configs['es-vwdata'];
export const getMolecularCdnServiceConfig = () =>
  featureServicesMirror['service-config-provider'].configs['es-molecular-cdn'];
export const getMolecularServiceConfig = () => featureServicesMirror['service-config-provider'].configs['es-molecular'];
export const getOneformBFFCdnServiceConfig = () => featureServicesMirror['service-config-provider'].configs['es-oneform-bff-cdn'];
